import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const industries = [
  { name: "Restaurants & Cafes", icon: "Coffee" },
  { name: "Retail Stores", icon: "ShoppingBag" },
  { name: "Corporate Offices", icon: "Briefcase" },
  { name: "Hotels & Hospitality", icon: "Home" },
  { name: "Medical Practices", icon: "Heart" },
  { name: "Salons & Spas", icon: "Scissors" },
  { name: "Warehouses", icon: "Box" },
  { name: "Event Venues", icon: "Mic" },
  { name: "Creative Agencies", icon: "Monitor" },
];

const Industries = () => {
  return (
    <section id="industries" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Connecting NYC's Diverse Businesses</h2>
          <p className="text-lg text-slate-600">
            We understand that a coffee shop's networking needs differ drastically from a medical office. We design bespoke solutions for every industry.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {industries.map((ind, idx) => {
            // Using a generic icon if specific one isn't in standard Fi list easily mapped, but we'll try to map common ones.
            // For simplicity in this artifact, we map to existing Fi icons.
            const iconMap = {
              Coffee: FiIcons.FiCoffee,
              ShoppingBag: FiIcons.FiShoppingBag,
              Briefcase: FiIcons.FiBriefcase,
              Home: FiIcons.FiHome,
              Heart: FiIcons.FiHeart,
              Scissors: FiIcons.FiScissors,
              Box: FiIcons.FiArchive,
              Mic: FiIcons.FiMic,
              Monitor: FiIcons.FiMonitor
            };
            const IconComp = iconMap[ind.icon] || FiIcons.FiWifi;

            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.05 }}
                className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 flex flex-col items-center justify-center text-center hover:shadow-md hover:border-blue-200 transition-all cursor-pointer group"
              >
                <div className="w-12 h-12 bg-slate-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-50 transition-colors">
                  <SafeIcon icon={IconComp} className="text-2xl text-slate-400 group-hover:text-blue-600 transition-colors" />
                </div>
                <h4 className="font-semibold text-slate-800 text-sm">{ind.name}</h4>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;